import React, { createContext, useState, useEffect, useContext } from 'react';
import {useLocation, useParams} from 'react-router-dom';
import { useCoreStateContext,useCoreContext } from 'spark-core-dx/contexts';
import { useCoreRoute } from 'spark-core-dx/hooks';
import ConvokeSourceObjectManager from '../../managers/convoke/ConvokeSourceObjectManager';
import ConvokeEntityObjectManager from '../../managers/convoke/ConvokeEntityObjectManager';
import { Operations } from '../../services/ItemServices';

export const ConvokeDomainContext = createContext();

export function ConvokeDomainContextProvider({ children }) {
    const coreState = useCoreStateContext();
    const coreContext = useCoreContext();
    const location = useLocation();
    const { eoId, soId } = useParams();
    const { currentRoute } = useCoreRoute();
    const [loadingState, setLoadingState] = useState(true)
    const sourceObjectMgr = new ConvokeSourceObjectManager(soId, coreContext, coreState, Operations.SourceObjectItem.SearchSourceObject, true);
    const entityObjectMgr = new ConvokeEntityObjectManager(eoId, coreContext, coreState, Operations.EntityObjectItem.SearchEntityObject, true);
    useEffect(() => {
        return () => {
            coreState.clear()
        }
    }, [])

    useEffect(() => {
        const routeKey = currentRoute?.ItemName + "_data";
        if (!coreState.get(routeKey) || coreState.get(routeKey).loadingMetadata || coreState.get(routeKey).loadingSearch) {
            setLoadingState(true)
        } else if (!sourceObjectMgr.loading.All) {
            setLoadingState(false)
        }
    }, [coreState, location])


    return (
        <ConvokeDomainContext.Provider value={{ sourceObjectMgr,entityObjectMgr, loadingState: coreState.global.get('isNavigating') ? true : loadingState }}>
            {children}
        </ConvokeDomainContext.Provider>
    );
}
export const useConvokeDomainContext = () => useContext(ConvokeDomainContext);